// extracted by mini-css-extract-plugin
export default {"input":"common_input__0zNON","blockMath":"common_blockMath__rKiPz"};